import type {
  onChangeEventsInterface,
  useSearchFilterHookStates
} from "./internal";

export const assembleResult = (
  currentStates: useSearchFilterHookStates,
  onChangeEvents: onChangeEventsInterface
) => {
  const accountTypes = {
    value: currentStates.accountTypesValue,
    handleChange: onChangeEvents.accountTypesOnChange
  };
  const countries = {
    value: currentStates.countryValue,
    handleChange: onChangeEvents.CountryOnChange
  };
  const urls = {
    value: currentStates.urlValue,
    handleChange: onChangeEvents.urlOnChange
  };
  const controlCenterPlatforms = {
    value: currentStates.controlCenterPlatformsValue,
    handleChange: onChangeEvents.controlCenterPlatformnsChange
  };
  const id = {
    value: currentStates.idValue,
    handleChange: onChangeEvents.idOnChange
  };
  const name = {
    value: currentStates.nameValue,
    handleChange: onChangeEvents.nameOnChange
  };
  const verticalTypes = {
    value: currentStates.verticalTypesValue,
    handleChange: onChangeEvents.verticalTypesnChange
  };
  const postalCode = {
    value: currentStates.postalCodeValue,
    handleChange: onChangeEvents.postalCodeOnChange
  };
  const statuses = {
    value: currentStates.statusValue,
    handleChange: onChangeEvents.StatusesOnChange
  };
  const created = {
    after: {
      value: currentStates.dateAfterValue,
      handleChange: onChangeEvents.dateAfterOnChange
    },
    before: {
      value: currentStates.dateBeforeValue,
      handleChange: onChangeEvents.dateBeforeOnChange
    }
  };
  const states = {
    value: currentStates.stateValue,
    handleChange: onChangeEvents.StatesOnChange
  };
  const franchises = {
    matchAll: {
      value: currentStates.franchisesMatchAllValue,
      handleChange: onChangeEvents.franchisesMatchAllOnChange
    },
    matchAny: {
      value: currentStates.franchisesMatchAnyValue,
      handleChange: onChangeEvents.franchisesMatchAnyOnChange
    },
    matchNone: {
      value: currentStates.franchisesMatchNoneValue,
      handleChange: onChangeEvents.franchisesMatchNoneOnChange
    }
  };
  const dealerCodes = {
    values: {
      value: currentStates.dealerCodesValueMatchAll,
      handleChange: onChangeEvents.dealerCodesValueMatchAllOnChange
    },
    value: currentStates.dealerCodesMatchAll,
    handleChange: onChangeEvents.dealerCodesMatchAllOnChange
  };
  const resources = {
    matchAll: {
      value: currentStates.resourcesMatchAllValue,
      handleChange: onChangeEvents.resourcesMatchAllOnChange
    },
    matchAny: {
      value: currentStates.resourcesMatchAnyValue,
      handleChange: onChangeEvents.resourcesMatchAnyOnChange
    },
    matchNone: {
      value: currentStates.resourcesMatchNoneValue,
      handleChange: onChangeEvents.resourcesMatchNoneOnChange
    }
  };
  return {
    accountTypes,
    countries,
    urls,
    controlCenterPlatforms,
    id,
    name,
    verticalTypes,
    postalCode,
    statuses,
    created,
    states,
    franchises,
    dealerCodes,
    resources
  };
};
